import React from "react";
import { MeterIcon, AlarmsIcon, InsightsIcon, ReportsIcon, UsersIcon, RolesPermissionIcon, NodeIcon, SignalAntennaIcon, ClientsIcon, CategoriesIcon, } from "@ui/components/icons/SidebarIcons";
/**
 * Sidebar menu configuration
 *
 * @priority - Lower numbers appear first in mobile bottom navigation
 * @label - Display text for the menu item
 * @path - Route path
 * @icon - Function that returns icon component with dynamic color
 */
export const menuConfig = [
    {
        label: "",
        items: [
            {
                label: "sidebar.dashboard",
                path: "/dashboard",
                icon: (color) => React.createElement(MeterIcon, { color: color }),
                priority: 1,
            },
            {
                label: "sidebar.freeRoamingNodes",
                path: "/free-roaming-nodes",
                icon: (color) => React.createElement(SignalAntennaIcon, { color: color }),
                priority: 2,
            },
            {
                label: "sidebar.nodes",
                path: "/nodes",
                icon: (color) => React.createElement(NodeIcon, { color: color }),
                priority: 3,
            },
            {
                label: "sidebar.alarms",
                path: "/alarms",
                icon: (color) => React.createElement(AlarmsIcon, { color: color }),
                priority: 4,
            },
        ],
    },
    {
        label: "sidebar.analytics",
        items: [
            {
                label: "sidebar.insights",
                path: "/insights",
                icon: (color) => React.createElement(InsightsIcon, { color: color }),
                priority: 4,
            },
            {
                label: "sidebar.reports",
                path: "/reports",
                icon: (color) => React.createElement(ReportsIcon, { color: color }),
                priority: 5,
            },
        ],
    },
    {
        label: "sidebar.settings",
        items: [
            {
                label: "sidebar.clients",
                path: "/clients",
                icon: (color) => React.createElement(ClientsIcon, { color: color }),
                priority: 9,
            },
            {
                label: "sidebar.categories",
                path: "/categories",
                icon: (color) => React.createElement(CategoriesIcon, { color: color }),
                priority: 10,
            },
            {
                label: "sidebar.users",
                path: "/users",
                icon: (color) => React.createElement(UsersIcon, { color: color }),
                priority: 7,
            },
            {
                label: "sidebar.rolesPermissions",
                path: "/roles",
                icon: (color) => React.createElement(RolesPermissionIcon, { color: color }),
                priority: 8,
            },
        ],
    },
];
/**
 * Mobile Bottom Navigation Configuration
 * Controls how many items are visible in bottom nav for different screen sizes
 */
export const mobileNavConfig = {
    phone: {
        visibleCount: 4, // Number of items visible on phones
    },
    tablet: {
        visibleCount: 6, // Number of items visible on tablets/iPads
    },
};
